import React from 'react';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/DefaultSelectDropdown';
import { ViewMode } from '../types';

export interface DialogViewModeSelectorProps {
  viewMode: ViewMode;
  onViewModeChange: (mode: ViewMode) => void;
  inline: boolean;
  absolute?: boolean;
}

/**
 * View mode selector component for DialogWizard
 */
export function DialogViewModeSelector({
  viewMode,
  onViewModeChange,
  inline,
  absolute = false,
}: DialogViewModeSelectorProps) {
  // When positioned absolutely, no wrapper padding is needed
  if (absolute) {
    return (
      <Select
        value={viewMode}
        onValueChange={(value: ViewMode) => onViewModeChange(value)}
      >
        <SelectTrigger className="w-[200px]">
          <SelectValue placeholder="Select mode" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="edit">Edit Mode</SelectItem>
          <SelectItem value="play">Play Mode</SelectItem>
          <SelectItem value="flow">Flow Mode</SelectItem>
        </SelectContent>
      </Select>
    );
  }
  
  return (
    <div className={inline ? "flex-shrink-0 max-w-6xl mx-auto px-6 pt-4 pb-2 w-full" : "flex-shrink-0 px-6 pt-4 pb-2"}>
      <Select
        value={viewMode}
        onValueChange={(value: ViewMode) => onViewModeChange(value)}
      >
        <SelectTrigger className="w-[200px]">
          <SelectValue placeholder="Select mode" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="edit">Edit Mode</SelectItem>
          <SelectItem value="play">Play Mode</SelectItem>
          <SelectItem value="flow">Flow Mode</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
}

